import React from 'react';

import { Channel } from '@kaltura-ott/tvpil-shared';

import { config } from 'components/pages/Epg/config';

import ProgramsList from './components/ProgramsList/ProgramsList';
import { usePrrogramsLineCombiner } from './hooks';

import styles from './ProgramsInner.module.scss';

interface Props {
  channel: Channel;
}

function ProgramsInner({ channel }: Props) {
  const { visible, ref } = usePrrogramsLineCombiner();

  return (
    <div ref={ref} data-target={channel.title} className={styles.item} style={{ height: config.channelLineHeight }}>
      {visible && <ProgramsList channel={channel} />}
    </div>
  );
}

export default ProgramsInner;
